import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EnvService } from './env.service';
import { CheckDigitalProfileResponse, ProfileDetails } from '../models/sign-in.models';
import { DateOfBirth, RegisterProfilePayload, UserRegistration } from '../feature/sign-in/pages/user-profile/model/model.userProfileForm';

@Injectable({
  providedIn: 'root'
})
export class SignInService {

  constructor( private http: HttpClient, private envService: EnvService ) { }

  private getPhoneUrl(envApiUrl: string, walletAddress: string): string {
    return `${envApiUrl}/v2/profile?providerAccountAddress=${walletAddress}`
  }

  // GET - /stellaradapterservice/v2/profile?providerAccountAddress={someWalletAddress}
  getPhoneByWallet(walletId: string): Observable<any> { // Todo: tim: fix types
    let result;
    // walletId = 'BekTestAddress6' // TODO: remove: #mar25 mock param
    try {
      result = this.http.get(this.getPhoneUrl(this.envService.apiUrl, walletId));
      return result;
    } 
    catch (error) {
      // Todo: Tim: this is the wrong way to handle errors. We should throw the error to the function calling this function.
      console.error('error gettingprofile by walletId', error);
      const errPromise = new Promise((resolve, reject) => {
        resolve({error: true});
      });
      return of(errPromise);
      // return errPromise;
    }
  }

  // POST - /stellaradapterservice/v2/profile/pre-check 
  // req {
  //   "phoneNumber": "6124816161",
  //   "countryDialCode": "1"
  // }
  checkDigitalProfile(phoneNumber: string | null, countryDialCode: string | null): Observable<any> { // Todo: Tim: fix types
    let result: any; // Todo: Tim: fix types

    const payload = {
      phoneNumber: phoneNumber,
      countryDialCode: countryDialCode
    }

    try {
      result = this.http.post(`${this.envService.apiUrl}/v2/profile/pre-check`, payload);
      return result;
    } 
    catch (error) {
      console.error('error checkDigitalProfile', error);
      const errPromise = new Promise<any>((resolve, reject) => {
        resolve({error: true});
      });
      return of(errPromise);
    }
  }

  // Create/Update Product
  // PUT {{stellarurl}}/stellaradapterservice/v2/profile/{dpid}/wallet/{walletAddress}
  updateProfileProductType(dpid: string, walletId: string) {
    console.log('*** dpid', dpid); // Todo: remove: #may6
    let result;
    try {
      result = this.http.put(`${this.envService.apiUrl}/v2/profile/${dpid}/wallet/${walletId}`, {});
      return result;
    }
    catch (error) {
      console.error('error updateProfileProductType', error);
      const err = { error };
      return of(err);
    }
  }


  registerNewProfile(profileDetails: ProfileDetails): Observable<any> {
    const { userRegistration, walletId, email, phoneNumber, dialCode, fbAuthToken } = profileDetails;
    let result;

    const payload: RegisterProfilePayload = this.buildProfilePayload(userRegistration, walletId, email, phoneNumber, dialCode);

    const headers = new HttpHeaders({
      'X-Firebase-Auth': fbAuthToken
    })
    try {
      result = this.http.post(`${this.envService.apiUrl}/v2/profile`, payload, { headers })
      return result;
    } 
    catch (error) {
      console.error('error registerNewProfile', error);
      const errPromise = new Promise((resolve, reject) => {
        resolve({error: true});
      });
      return of(errPromise);
    }
  }

  // Todo: Tim: this is a pure function, move this to a utils file
  private buildProfilePayload(consumerProfile: UserRegistration, userWalletId: string, userEmail: string, userPhoneNumber: string, userDialCode: string): RegisterProfilePayload {
    let profilePayload: RegisterProfilePayload;
    profilePayload = {
      targetAudience: null,
      userLanguage: "",
      digitalProfileType: "DPID",
      consumer: {
        firstName: consumerProfile.firstName,
        middleName: consumerProfile.middleName,
        lastName: consumerProfile.lastName,
        secondLastName: "",
        genderCode: null,
        address: {
          line1: consumerProfile.address,
          line2: "",
          line3: null,
          city: consumerProfile.cityOrTown,
          countrySubdivisionCode: consumerProfile.state,
          countryCode: consumerProfile.country,
          postalCode: consumerProfile.postalCode
        },
        mobilePhone: {
          number: userPhoneNumber,
          countryDialCode: userDialCode
        },
        email: userEmail,
        enrolInRewards: null,
        notificationPreferences: null,
        notificationLanguagePreference: null,
        dateOfBirth: this.convertDOBtoString(consumerProfile.dateOfBirth),
        birthCity: null,
        birthCountryCode: consumerProfile.countryOfBirth,
        citizenshipCountryCode: null
      }
    };
    return profilePayload;
  }

  private convertDOBtoString(dateOfBirth: DateOfBirth): string {
    let dobString: string = `${dateOfBirth.year}-${dateOfBirth.month}-${dateOfBirth.day}`;
    return dobString;
  }
}
